import { LitElement, html, css } from 'lit';

const ICONS = {
  desktop: html`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>`,
  shield: html`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>`,
  puzzle: html`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"/><path d="M8 10v4"/><path d="M12 10v2"/><path d="M16 10v6"/></svg>`,
  chat: html`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>`,
  envelope: html`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>`,
  calendar: html`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>`,
  folder: html`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>`,
  terminal: html`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="4 17 10 11 4 5"/><line x1="12" y1="19" x2="20" y2="19"/></svg>`,
  grid: html`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>`,
  layers: html`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>`,
  robot: html`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="10" rx="2"/><circle cx="12" cy="5" r="2"/><path d="M12 7v4"/><line x1="8" y1="16" x2="8" y2="16"/><line x1="16" y1="16" x2="16" y2="16"/></svg>`,
  default: html`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>`,
};

export class SiteFeatureBox extends LitElement {
  static properties = {
    icon: { type: String },
    title: { type: String },
    description: { type: String },
  };

  static styles = css`
    :host {
      display: block;
    }
    .card {
      background: var(--color-bg-card, rgba(26, 26, 46, 0.6));
      border: 1px solid var(--color-border, rgba(255,255,255,0.08));
      border-radius: 0.75rem;
      padding: var(--space-8, 2rem);
      transition: all var(--transition-base, 0.25s ease);
      height: 100%;
      box-shadow: 0 16px 38px rgba(42, 51, 112, 0.08);
      backdrop-filter: blur(16px);
      -webkit-backdrop-filter: blur(16px);
    }
    .card:hover {
      border-color: var(--color-border-hover, rgba(255,255,255,0.15));
      transform: translateY(-4px);
      box-shadow: 0 18px 44px rgba(42, 51, 112, 0.13);
    }
    .icon {
      width: 3rem;
      height: 3rem;
      border-radius: 0.5rem;
      background: var(--color-accent-dim, rgba(0, 212, 255, 0.15));
      color: var(--color-accent, #00d4ff);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: var(--space-5, 1.25rem);
    }
    .title {
      font-size: var(--text-lg, 1.125rem);
      font-weight: var(--font-semibold, 600);
      margin-bottom: var(--space-3, 0.75rem);
      color: var(--color-text-primary, #f0f0f5);
    }
    .desc {
      font-size: var(--text-sm, 0.875rem);
      color: var(--color-text-secondary, #a0a0b8);
      line-height: var(--leading-relaxed, 1.7);
    }
  `;

  render() {
    const iconSvg = ICONS[this.icon] || ICONS.default;

    return html`
      <div class="card">
        <div class="icon">${iconSvg}</div>
        <div class="title">${this.title || ''}</div>
        <div class="desc">${this.description || ''}</div>
      </div>
    `;
  }
}

customElements.define('site-feature-box', SiteFeatureBox);
